<template>
  <div class="independent-wrapper">
    <div class="content">
      <div class="title">
        <span class="border"></span>
        <i class="el-icon-location-outline"></i> 用户管理 &gt; 账号管理（平台 / 机构管用户）
      </div>

      <div class="contentLeft">
        <div class="con">
          <!-- 筛选条 -->
          <div class="toolbar">
            <el-input
              v-model="query.keyword"
              clearable
              placeholder="账号 / 姓名 / 手机号 / 机构"
              style="width: 240px; margin-right: 10px;"
              @keyup.enter="handleSearch"
            />
            <el-select
              v-model="query.role"
              placeholder="全部角色"
              clearable
              style="width: 140px; margin-right: 10px;"
              @change="handleSearch"
            >
              <el-option label="管理员" :value="0" />
              <el-option label="机构用户" :value="1" />
            </el-select>
            <el-select
              v-model="query.state"
              placeholder="全部状态"
              clearable
              style="width: 120px; margin-right: 10px;"
              @change="handleSearch"
            >
              <el-option label="有效" value="1" />
              <el-option label="失效" value="0" />
            </el-select>
            <el-select
              v-model="query.auditStatus"
              placeholder="全部审核"
              clearable
              style="width: 130px; margin-right: 10px;"
              @change="handleSearch"
            >
              <el-option label="待审核" :value="0" />
              <el-option label="已通过" :value="1" />
              <el-option label="已拒绝" :value="2" />
            </el-select>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="resetQuery">重置</el-button>
          </div>

          <!-- 表格 -->
          <div class="table-con consiliaTable">
            <el-table
              :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
              tooltip-effect="dark"
              style="width: 100%"
              :data="tableData"
              v-loading="loading"
            >
              <el-table-column align="center" label="ID" prop="id" width="60" />
              <el-table-column align="center" label="账号" prop="username" width="140">
                <template #default="{ row }">{{ row.username || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="姓名" prop="name" width="120">
                <template #default="{ row }">{{ row.name || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="手机号" prop="phone" width="120">
                <template #default="{ row }">{{ row.phone || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="所属机构" prop="hospitalName" min-width="140">
                <template #default="{ row }">{{ row.hospitalName || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="科室" prop="departmentName" width="100">
                <template #default="{ row }">{{ row.departmentName || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="角色" width="120">
                <template #default="{ row }">
                  <el-tag
                    :type="row.role === 0 ? 'danger' : 'info'"
                    size="small"
                  >
                    {{ row.role === 0 ? '管理员' : '机构用户' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="状态" width="80">
                <template #default="{ row }">
                  <span :style="{ color: row.state === '1' ? '#67c23a' : '#f56c6c' }">
                    {{ row.state === '1' ? '有效' : '失效' }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="审核" width="90">
                <template #default="{ row }">
                  <el-tag
                    :type="auditTagType(row.auditStatus)"
                    size="small"
                  >
                    {{ auditLabel(row.auditStatus) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="注册类型" width="100">
                <template #default="{ row }">
                  {{ row.registerType === 0 ? '本地注册' : '辅诊系统' }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="注册时间" prop="registerTime" width="160" />
              <el-table-column align="center" label="操作" min-width="240" fixed="right">
                <template #default="{ row }">
                  <template v-if="isSelf(row)">
                    <span style="color: #999;">当前账号</span>
                  </template>
                  <template v-else>
                    <!-- 待审核 → 显示 通过 / 拒绝 -->
                    <template v-if="row.auditStatus === 0">
                      <span class="editor" @click="auditRow(row, 1)">通过</span>
                      <span class="del" @click="auditRow(row, 2)">拒绝</span>
                    </template>
                    <!-- 已通过/拒绝 → 显示 改角色 + 启停 -->
                    <template v-else>
                      <span class="editor" @click="toggleRole(row)">
                        {{ row.role === 0 ? '降为机构用户' : '提升为管理员' }}
                      </span>
                      <span
                        :class="row.state === '1' ? 'del' : 'editor'"
                        @click="toggleState(row)"
                      >
                        {{ row.state === '1' ? '停用' : '启用' }}
                      </span>
                      <span
                        v-if="row.auditStatus === 2"
                        class="editor"
                        @click="auditRow(row, 1)"
                      >重新通过</span>
                    </template>
                  </template>
                </template>
              </el-table-column>
            </el-table>

            <div class="pagination-wrap">
              <el-pagination
                background
                layout="total, prev, pager, next"
                :total="total"
                :current-page="query.current"
                :page-size="query.size"
                @current-change="handlePageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosconf from '../../api/axiosconf'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      query: {
        current: 1,
        size: 10,
        keyword: '',
        role: null,
        state: null,
        auditStatus: null,
      },
      myUserId: null,
    }
  },
  mounted() {
    const raw = localStorage.getItem('loginInfo')
    if (raw) {
      try {
        const u = JSON.parse(raw)
        this.myUserId = u && u.id
      } catch (e) { /* ignore */ }
    }
    this.fetchList()
  },
  methods: {
    isSelf(row) {
      return this.myUserId != null && Number(this.myUserId) === Number(row.id)
    },
    handleSearch() {
      this.query.current = 1
      this.fetchList()
    },
    resetQuery() {
      this.query.keyword = ''
      this.query.role = null
      this.query.state = null
      this.query.auditStatus = null
      this.query.current = 1
      this.fetchList()
    },
    auditTagType(s) {
      if (s === 0) return 'warning'
      if (s === 1) return 'success'
      if (s === 2) return 'danger'
      return 'info'
    },
    auditLabel(s) {
      if (s === 0) return '待审核'
      if (s === 1) return '已通过'
      if (s === 2) return '已拒绝'
      return '-'
    },
    async auditRow(row, auditStatus) {
      const text = auditStatus === 1 ? '通过审核' : '拒绝审核'
      try {
        await this.$confirm(`确定${text}「${row.username || row.name || row.id}」？`, '提示', {
          type: auditStatus === 1 ? 'success' : 'warning',
        })
        const res = await axiosconf.applicationJson('/business/user/admin/audit', {
          id: row.id,
          auditStatus,
        })
        if (res.data && res.data.code === 0) {
          this.$message.success(`${text}成功`)
          this.fetchList()
        } else {
          this.$message.error((res.data && res.data.msg) || '操作失败')
        }
      } catch (e) {
        // 用户取消或异常
      }
    },
    handlePageChange(page) {
      this.query.current = page
      this.fetchList()
    },
    async fetchList() {
      this.loading = true
      try {
        const params = { ...this.query }
        Object.keys(params).forEach(k => {
          if (params[k] === null || params[k] === '') delete params[k]
        })
        const res = await axiosconf.applicationJson('/business/user/admin/list', params)
        if (res.data && res.data.code === 0) {
          const data = res.data.data || {}
          this.tableData = data.records || []
          this.total = data.total || 0
        } else {
          this.$message.error((res.data && res.data.msg) || '加载失败')
        }
      } catch (e) {
        console.error('获取账号列表失败', e)
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    async toggleRole(row) {
      const newRole = row.role === 0 ? 1 : 0
      const text = newRole === 0 ? '提升为管理员' : '降为机构用户'
      try {
        await this.$confirm(`确定将「${row.username || row.name || row.id}」${text}？`, '提示', {
          type: 'warning',
        })
        const res = await axiosconf.applicationJson('/business/user/admin/role', {
          id: row.id,
          role: newRole,
        })
        if (res.data && res.data.code === 0) {
          this.$message.success('修改成功')
          this.fetchList()
        } else {
          this.$message.error((res.data && res.data.msg) || '修改失败')
        }
      } catch (e) {
        // 用户取消或异常
      }
    },
    async toggleState(row) {
      const newState = row.state === '1' ? '0' : '1'
      const text = newState === '0' ? '停用' : '启用'
      try {
        await this.$confirm(`确定${text}「${row.username || row.name || row.id}」？`, '提示', {
          type: 'warning',
        })
        const res = await axiosconf.applicationJson('/business/user/admin/state', {
          id: row.id,
          state: newState,
        })
        if (res.data && res.data.code === 0) {
          this.$message.success(`${text}成功`)
          this.fetchList()
        } else {
          this.$message.error((res.data && res.data.msg) || '操作失败')
        }
      } catch (e) {
        // 用户取消或异常
      }
    },
  },
}
</script>

<style scoped>
.independent-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.content {
  padding: 20px;
}
.title {
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}
.title .border {
  display: inline-block;
  width: 3px;
  height: 14px;
  background: #679FF6;
  margin-right: 8px;
  vertical-align: middle;
}
.toolbar {
  margin-bottom: 16px;
}
.editor {
  color: #679FF6;
  cursor: pointer;
  margin-right: 12px;
}
.del {
  color: #f56c6c;
  cursor: pointer;
  margin-right: 12px;
}
.pagination-wrap {
  margin-top: 16px;
  text-align: right;
}
</style>
